import { applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';

import api from 'middleware/api';
const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default composeEnhancers(applyMiddleware(thunk, api));
